import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { getActiveLanguage, getLanguages, getTranslate, withLocalize } from 'react-localize-redux'

import * as Routes from 'constants/Routes'
import styles from './Footer.module.scss'
import { getUser, getUserLang } from 'common/selectors/user'
import { setActiveLanguage } from 'common/actions/localize'
import { setActiveMeasurementSystem } from 'common/actions/measurementSystem'
import LanguageSelector from 'common/components/LanguageSelector/LanguageSelector'

const Footer = props => {
  const { translate, setActiveLanguage, activeLanguage, userLanguage, languages, isLoggedIn } =
    props
  const lang = userLanguage ? userLanguage.toUpperCase() : activeLanguage.name

  const redirect = route => {
    browserHistory.push(route)
  }

  const handlePolicyLink = () => {
    redirect(Routes.POLICY)
  }

  const handleTermsLink = () => {
    redirect(Routes.TERMS)
  }

  const handleCookiesLink = () => {
    redirect(Routes.COOKIES)
  }

  const changeSelectedLanguage = lang => {
    setActiveLanguage(lang)
  }

  const Language = () => {
    return (
      <div className={styles.languageSelector}>
        <LanguageSelector
          onChange={changeSelectedLanguage}
          selected={lang}
          translate={translate}
          languages={languages}
          position='topRight'
        />
      </div>
    )
  }

  const MobileFooter = () => {
    return (
      <div className={styles.mobileFooter}>
        <div className={styles.footerContent}>
          <div className={styles.copyright}>
            <p className={styles.copyrightText}>{translate('copyright')}</p>
          </div>
          {!isLoggedIn && (
            <div>
              <hr className={styles.divider} />
              <div className={styles.contact}>
                <div className={styles.linkWrapper}>
                  <a
                    className={styles.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://www.inbiotair.com/'
                  >
                    {translate('discoverInbiot')}
                  </a>
                </div>
                <div>
                  <a
                    className={styles.link}
                    rel='noopener'
                    onClick={ev => {
                      ev.preventDefault()
                      handleTermsLink()
                    }}
                    href='/#'
                  >
                    {translate('acceptPolicyandTerms.terms')}
                  </a>
                </div>
                <div>
                  <a
                    className={styles.link}
                    rel='noopener'
                    onClick={ev => {
                      ev.preventDefault()
                      handlePolicyLink()
                    }}
                    href='/#'
                  >
                    {translate('acceptPolicyandTerms.policy')}
                  </a>
                </div>
                <div>
                  <a
                    className={styles.link}
                    rel='noopener'
                    onClick={ev => {
                      ev.preventDefault()
                      handleCookiesLink()
                    }}
                    href='/#'
                  >
                    {translate('acceptPolicyandTerms.cookies')}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.component}>
      <div className={styles.mobileFooterWrapper}>
        <MobileFooter />
      </div>
      <div className={styles.content}>
        <div className={styles.footerContent}>
          <Language />
          <div className={styles.contact}>
            <div className={styles.linkWrapper}>
              <a
                className={styles.link}
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.inbiotair.com/'
              >
                {translate('discoverInbiot')}
              </a>
            </div>
            <div>
              <a
                className={styles.link}
                rel='noopener'
                onClick={ev => {
                  ev.preventDefault()
                  handleTermsLink()
                }}
                href='/#'
              >
                {translate('acceptPolicyandTerms.terms')}
              </a>
            </div>
            <div>
              <a
                className={styles.link}
                rel='noopener'
                onClick={ev => {
                  ev.preventDefault()
                  handlePolicyLink()
                }}
                href='/#'
              >
                {translate('acceptPolicyandTerms.policy')}
              </a>
            </div>
            <div>
              <a
                className={styles.link}
                rel='noopener'
                onClick={ev => {
                  ev.preventDefault()
                  handleCookiesLink()
                }}
                href='/#'
              >
                {translate('acceptPolicyandTerms.cookies')}
              </a>
            </div>
          </div>
          <div className={styles.copyright}>
            <p className={styles.copyrightText}>{translate('copyright')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: getUser(state),
  userLanguage: getUserLang(state),
  activeLanguage: getActiveLanguage(state.localize),
  languages: getLanguages(state.localize),
  translate: getTranslate(state.localize)
})

const mapActionsToProps = {
  setActiveLanguage,
  setActiveMeasurementSystem
}

export default connect(mapStateToProps, mapActionsToProps)(withLocalize(Footer))
